import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-4 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddBoxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddBoxSharp.js
// module id = 1871
// module chunks = 2